// removed by extract-text-webpack-plugin
module.exports = {"tooltipHolder":"styles__tooltipHolder__M5g8e","tooltip":"styles__tooltip__148hS","tooltiptext":"styles__tooltiptext__nd4IU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/styles.scss
// module id = 847
// module chunks = 0